/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */

export default function GetPRPQuery() {
    /* Are we in per-request AP?
     * Page URLs in per-request AP include non-empty 'state' query parameter.
     */
    const match = window.location.search.match(/(?:^\?|&)(state=[^&]+)/);
    return match && match[1] ? match[1] : undefined;
}
